import { AnalyticsTypes } from '../../middleware/google-analytics';
import * as TrackingConstants from '../../EventTrackingConstants';
import { CROSS_PAGE_ACTION_NAMES } from './constants';

export const ActionTypes = {
    TRACK_PREVIOUS_MONOLITH_ACTION: '@@crossPageActions/TRACK_PREVIOUS_MONOLITH_ACTION',
    TRACK_THEMED_SEARCH_CLICK: '@@crossPageActions/tracking/TRACK_THEMED_SEARCH_CLICK',
};

export const trackPreviousMonolithAction = ({
    action,
    category,
    label,
    pageId,
}) => ({
    type: ActionTypes.TRACK_PREVIOUS_MONOLITH_ACTION,
    meta: {
        analytics: {
            action,
            type: AnalyticsTypes.TrackPreviousMonolithEvent,
            category,
            label,
            pageId,
        },
    },
});

export const destinationPageActions = {
    [CROSS_PAGE_ACTION_NAMES.trackThemedSearchClick]: ({ description }) => ({
        type: ActionTypes.TRACK_THEMED_SEARCH_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: description,
                data: {
                    Component: TrackingConstants.TARGETS.THEMED_SEARCH,
                    Element: TrackingConstants.TARGETS.THEMED_SEARCH,
                    Initiator: TrackingConstants.INTERACTION_TYPES.CLICK,
                    Section: TrackingConstants.TARGETS.THEMED_SEARCH,
                },
            },
        },
    }),
};
